import { Crop } from './crop';

export class Commodity {
  id?: number;
  name?: string;
  unit?: string;
  seedUnitType?: string;
  crops?: Array<Crop>;
  colorR?: number;
  colorG?: number;
  colorB?: number;
  imgUrl?: string;
  nameTranslated?: string;
  eppo?: string;

  constructor() {
    this.id = null;
    this.name = '';
    this.unit = 'kg';
    this.seedUnitType = 'count';
    this.crops = [];
    this.colorR = null;
    this.colorG = null;
    this.colorB = null;
    this.imgUrl = null;
    this.nameTranslated = null;
    this.eppo = null;
  }
}

/*
*********** MODELLO DI BACKEND **********************

package com.xfarm.api.v1.lists

import com.xfarm.api.v1.auth.User
import com.xfarm.api.v1.core.Crop

class Commodity {

    transient springSecurityService

    Long    companyId = -1
    string  name
    string  unit = 'kg'
    string  seedUnitType = 'count'
    Integer colorR
    Integer colorG
    Integer colorB

    static hasMany = [crops: Crop]

    static constraints = {
        // TODO Fix beforeInsert and beforeUpdate Events Bugs and set compoanyId nullable:false
        companyId       blank: false
        name            blank: false
        unit            blank: false, inList: ["kg"]
        seedUnitType    blank: false, inList: ["count", "weight"]
        colorR          blank: false, nullable: true
        colorG          blank: false, nullable: true
        colorB          blank: false, nullable: true

    }

    static transients = ['springSecurityService']

    def beforeInsert() {
        companyId = User.get(springSecurityService?.principal?.id)?.farm?.id
    }

    def beforeUpdate() {
        if(companyId != User.get(springSecurityService?.principal?.id)?.farm?.id){
            return false
        }
    }
}

*/
